import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetEmployeeRoleOverview } from "widgets";
import { WidgetEmployeeRoleOverviewPreviewQuery } from "./__generated__/WidgetEmployeeRoleOverviewPreviewQuery.graphql";

type Props = {
  storecastId?: string;
  query: PreloadedQuery<WidgetEmployeeRoleOverviewPreviewQuery>;
};

export const WIDGET_EMPLOYEE_ROLE_OVERVIEW_PREVIEW_QUERY = graphql`
  query WidgetEmployeeRoleOverviewPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetEmployeeRoleOverviewInput!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetEmployeeRoleOverview(input: $input) {
        ...WidgetEmployeeRoleOverview_widget
      }
    }
  }
`;
export function WidgetEmployeeRoleOverviewPreview(props: Props) {
  const data = usePreloadedQuery<WidgetEmployeeRoleOverviewPreviewQuery>(
    WIDGET_EMPLOYEE_ROLE_OVERVIEW_PREVIEW_QUERY,
    props.query
  );

  return (
    <WidgetEmployeeRoleOverview
      mode="IDLE"
      interactive={false}
      widget={data.dashboard.previewWidgetEmployeeRoleOverview}
      storecastId={props.storecastId ?? ""}
    />
  );
}
